<template>
  <div class="formulario-resultado-llamada">
    <titulo-seccion titulo="RESULTADO DE LA LLAMADA"></titulo-seccion>
    <div class="container container-agenda">
      <form @submit="validarResultadoLlamada">
        <div class="col-lg-12 col-sm-12">
          <p class="parrafo-instrucciones parrafo-agenda mt-2">
            Especifica la consecuencia de la llamada realizada con el prospecto
          </p>
        </div>
        <div class="inputs-agenda">
          <div class="col-lg-12 col-sm-12">
            <label class="label-formulario-solicitud label-agenda"
              >Respuesta</label
            >
          </div>
          <div class="col-lg-12 col-sm-12">
            <DropDown
              placeholder="Selecciona una respuesta *"
              :arreglo="this.catalogos.respuestas"
              llave="caminoId"
              valor="caminoId"
              texto="nombre"
              v-model="DatosRespuesta.RespuestaId"
              :requerido="true"
            ></DropDown>
          </div>
          <div class="inputs-cancela">
            <div
              class="form-group col-lg-12 col-sm-12"
              v-if="DatosRespuesta.RespuestaId == 3"
            >
              <DropDown
                placeholder="Selecciona el mótivo de cancelación *"
                :arreglo="this.catalogos.motivosCancelacion"
                llave="motivoCancelacionId"
                valor="motivoCancelacionId"
                texto="motivo"
                v-model="SlctMotivoCancelacion"
                :requerido="true"
              ></DropDown>
            </div>
            <div
              class="form-group col-lg-12 col-sm-12 mt-1"
              v-if="DatosRespuesta.RespuestaId == 3"
            >
              <textarea
                placeholder="Observaciones"
                class="form-control campo-basico"
                rows="3"
                v-model="Observaciones"
              ></textarea>
            </div>
          </div>
          <div class="form-group col-lg-12 col-sm-12 mt-3">
            <button
              v-if="loadingResultadoLlamada"
              disabled
              class="btn w-100 boton-primario boton-agenda mb-3"
            >
              <v-progress-circular
                indeterminate
                size="30"
                color="white"
              ></v-progress-circular>
            </button>
            <button
              v-else
              type="submit"
              class="btn w-100 boton-primario boton-agenda mb-3"
            >
              Guardar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="js">
import axios from "axios";

import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import DropDown from "../components/DropDown.vue";
import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion";

//Variables
var rutaControlador = "/api/Master/Cancelacion/ListarMotivosCancelacionLlamada";
var rutaCargarResultados = "/api/Master/Etapa/ObtenerCaminosDeEtapaRealizarLlamada";
var rutaGuardarResultadoLlamada = "/api/Master/Llamada/GuardarResultadoLLamada";
export default {
  name: "ResultadoLlamada",
  components: {
    TituloSeccion,
    DropDown
  },
  mixins:[mixinSolicitudInscripcion],
  data() {
    return {
      catalogos: {
        respuestas:[],
        motivosCancelacion: []
      },
      DatosRespuesta: {
        RespuestaId: null
      },
      loadingResultadoLlamada: false,
      SlctMotivoCancelacion:null,
      resultado:{
        LlamadaId:null,
        CaminoId:null,
        MotivoCancelacionId:null,
        Observaciones:null,
        ProspectoId:  this.$store.getters.prospectoId
      },
      llamadaId:0,
      prospectoId:  this.$store.getters.prospectoId
    };
  },
  methods: {
    validarResultadoLlamada: function(e) {
      e.preventDefault();
      if(parseInt(this.DatosRespuesta.RespuestaId) === 0){
        this.AlertaEmbajadores("Por favor selecciona un resultado.", true);
        return;
      }

      if(parseInt(this.DatosRespuesta.RespuestaId) === 3){
        if(parseInt(this.SlctMotivoCancelacion) === 0){
          this.AlertaEmbajadores("Por favor selecciona un motivo de cancelación", true);
          return;
        }

        if(this.esCadenaNulaOTodosEspaciosEnBlanco(this.Observaciones)){
          this.AlertaEmbajadores("Por favor ingresa la observación de cancelación.", true);
          return;
        }
      }
      const resultado = {
        "LlamadaId":this.llamadaId,
        "CaminoId":this.DatosRespuesta.RespuestaId,
        "MotivoCancelacionId":this.SlctMotivoCancelacion,
        "Observaciones":this.Observaciones,
        "ProspectoId":this.prospectoId
      }
      this.guardarResultadoLlamada(resultado);
    },
    guardarResultadoLlamada: function(resultado) {
      this.loadingResultadoLlamada= true;
      axios.post(rutaGuardarResultadoLlamada, resultado)
        .then(resp => {
          this.loadingResultadoLlamada= false;
          if (resp.data.estado === 0) {
            switch (parseInt(resultado.CaminoId)) {
              case 2:
                this.$router.push({
                  name: "RegistroLlamada"
                });
                break;
              case 4:
                this.$router.push({
                  name: "RegistroCita"
                });
                break;
              default:
                this.$router.push({
                  name: "AdministracionDeProspectos"
                });
                break;
            }
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch(e => {
          this.loadingResultadoLlamada= false;
          this.ManejarExcepcion(e);
        });

    },
    esCadenaNulaOTodosEspaciosEnBlanco: function(cadena) {
      return cadena === undefined || cadena === null
            || typeof cadena !== 'string'
            || cadena.match(/^ *$/) !== null;
    }
  },
  mounted() {
      axios
      .get(rutaCargarResultados)
      .then((resp) => {
        if (resp.data.estado === 0) {
          this.catalogos.respuestas = resp.data.data;
        } 
      })
      .catch(e => {
        this.ManejarExcepcion(e);
      });
  },
  watch: {
    "DatosRespuesta.RespuestaId": function (RespuestaId) {
      if(RespuestaId == 3){
        axios.get(rutaControlador)
             .then((resp) => {
                if (resp.data.estado === 0) {
                this.catalogos.motivosCancelacion = resp.data.data;
                } 
             })
            .catch((e) => {
              this.ManejarExcepcion(e);
            });
       }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";

.formulario-resultado-llamada {
  flex-grow: 1;
}
</style>
